import { api } from './client'

/**
 * TASK-0157: consumer for `LeadProvidersController` (backend, this same task —
 * `platform/Backend/src/Modules/Leads/EqualCrm.Modules.Leads/Api/LeadProvidersController.cs`).
 * Shape matches the controller's `List`/`Get` projection exactly (`Id, Name, ContactInfo,
 * ContractReference, Cost, BillingMode, Sectors, Sla, IntegrationMethod, Notes, IsActive,
 * CreatedAt, UpdatedAt`), camelCased the same way every other `api/*.ts` module in this
 * codebase mirrors a PascalCase backend entity (see `Department` in `./team.ts`). No
 * dedicated `api/departments.ts` exists to copy verbatim, so this follows the general
 * list/get/create/update/delete shape already used by `./leadRoutingRules.ts` (TASK-0148),
 * plus a `get` (present in most other `api/*.ts` modules — see e.g. `./campaigns.ts`).
 */
export interface LeadProvider {
  id: number
  name: string
  contactInfo?: string
  contractReference?: string
  cost?: number
  billingMode?: string
  sectors?: string
  sla?: string
  integrationMethod?: string
  notes?: string
  isActive: boolean
  createdAt: string
  updatedAt?: string
}

/** Body for create/update — mirrors `LeadProviderCreateRequest`/`LeadProviderUpdateRequest`
 * (`Name, ContactInfo, ContractReference, Cost, BillingMode, Sectors, Sla, IntegrationMethod,
 * Notes`) field-for-field. */
export interface LeadProviderRequestBody {
  name: string
  contactInfo?: string | undefined
  contractReference?: string | undefined
  cost?: number | undefined
  billingMode?: string | undefined
  sectors?: string | undefined
  sla?: string | undefined
  integrationMethod?: string | undefined
  notes?: string | undefined
}

export const leadProvidersApi = {
  list: () => api<LeadProvider[]>('/api/lead-providers'),
  get: (id: number) => api<LeadProvider>(`/api/lead-providers/${id}`),
  create: (data: LeadProviderRequestBody) =>
    api<{ id: number }>('/api/lead-providers', { method: 'POST', body: JSON.stringify(data) }),
  update: (id: number, data: LeadProviderRequestBody) =>
    api<void>(`/api/lead-providers/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  delete: (id: number) =>
    api<void>(`/api/lead-providers/${id}`, { method: 'DELETE' }),
}
